// extracted by mini-css-extract-plugin
export default {"container":"cDGpIT","listDividerColor":"h1FzKJ","cardBorderColor":"OpzQVO","listHoveredBorderColor":"hSwmbY"};